import StateCounter from '@/Utility/StateCounter';

/**
 * A counter responsible for setting the busy state when the count exceeds 0.
 */
export default class BusyCounter extends StateCounter<boolean> {
    constructor(isBusy: KnockoutObservable<boolean>) {
        super(isBusy, 0, () => false, () => true);
    }
}